import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import { StyledEntityImage } from "@/ui/EntityImage/Styled";
import { StyledLinkBase } from "@/ui/Link/StyledLink";
export const cssSwiperProductImages = "cssSwiperProductImages_c1afq5l3";
export const StyledPreviewImage = /*#__PURE__*/styled('div')({
  name: "StyledPreviewImage",
  class: "StyledPreviewImage_s1yby20x"
});
export const StyledPreview = /*#__PURE__*/styled(StyledEntityImage)({
  name: "StyledPreview",
  class: "StyledPreview_szkjnfv"
});

require("./StyledPreview.linaria.module.css!=!../../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./StyledPreview.tsx");